import { ILayer } from '../../../types/common';

const source = 'feed_trails';

const config = {
  id: source,
  type: 'line',
  source,
  layout: {
    visibility: 'visible',
  },
  paint: {
    'line-color': '#5CA2D1',
    'line-width': 1,
    'line-opacity': 1,
  },
};

const load = async (): Promise<ILayer> => {
  const response = await fetch('/geojson/feed_trails');
  const data = await response.json();

  return {
    data,
    config,
    source,
    labels: null,
    markers: null,
  };
};

export default load;
